// extracted by mini-css-extract-plugin
export var searchHeader = "_43-0";
export var searchHeaderDark = "_43-1";